class BlogVideoHero {
  constructor() {
    this.removeControls()
  }

  getHero = () => {
    return document.querySelector('.hero-blog video')
  }

  removeControls = () => {
    if (this.getHero()) this.getHero().removeAttribute('controls')
  }
}
